export default __webpack_public_path__ + "static/media/label-ecology.eaf2a94d.svg";